const validationStyles = {
  stepDetails: {
    padding: '16px',
  },
  container: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
  },
  leftSection: {
    width: '270px',
    marginRight: '20px',
  },
  rightSection: {
    flex: 1,
  },
  subtitle: {
    marginBottom: '8px',
    fontSize: '14px',
    color: '#333',
  },
  switchText: {
    marginBottom: '8px',
    fontSize: '14px',
    color: '#333',
    marginTop: '8px',
  },
  inputBox: {
    width: '100%',
    padding: '8px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    boxSizing: 'border-box',
  },
  toggleContainer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '8px',
  },
  switch: {
    position: 'relative',
    display: 'inline-block',
    width: '45px',
    height: '25px',
    marginLeft: '10px',
  },
  switchInput: {
    opacity: 0,
    width: 0,
    height: 0,
  },
  slider: {
    position: 'absolute',
    cursor: 'pointer',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#ccc',
    transition: '.4s',
    borderRadius: '25px',
  },
  sliderBefore: {
    position: 'absolute',
    content: '""',
    height: '19px',
    width: '19px',
    borderRadius: '50%',
    left: '3px',
    bottom: '3px',
    backgroundColor: 'white',
    transition: '.4s',
  },
  inputCheckedSlider: {
    backgroundColor: '#2196F3',
  },
  inputCheckedSliderBefore: {
    transform: 'translateX(20px)',
  },

  roundedButton: {
    borderRadius: '25px',
    padding: '8px 16px',
    backgroundColor: '#1890ff',
    color: '#fff',
    border: 'none',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

export default validationStyles;
